import React from 'react';
import { observer } from 'mobx-react';
import { toJS } from 'mobx';

// Translations
import translate from '../Translate.js';

// Helpers
import { toggleDrawer, confirm } from '../../helpers/helpers.js';

// Dependencies
import moment from 'moment';

// Components
import FauxSelect from '../Common/FauxSelect';
import ProctorGroupList from './ProctorGroupList';
import LoadMore from '../Common/LoadMore.js';

const StudentOverview = observer(class StudentOverview extends React.Component {
  constructor(props) {
    super();

    // Set the initial state
    this.state = {
      examEnrollments: toJS(props.examEnrollments),
      expanded: [],
      status: ''
    }

    // Bind this to functions
    this.applyFilters = this.applyFilters.bind(this);
    this.resetFilters = this.resetFilters.bind(this);
    this.selectOption = this.selectOption.bind(this);
    this.handleAction = this.handleAction.bind(this);
    this.renderResults = this.renderResults.bind(this);

  }



  selectOption(e, props) {
    const action = e.target.getAttribute('data-action');

    this.handleAction(
      e,
      action,
      props.enrollmentSid,
      props.userSid,
      props.sessionSid,
      props.configurationSid,
      props.studentName,
      props.sessionKey,
      props.crossListed,
      props.parentSchool,
      props.workflowModule
    );
  }

  handleAction(e, action, enrollmentSid, userSid, sessionSid, configurationSid, studentName, sessionKey, crossListed, parentSchool, workflowModule) {
    const drawerContent = action;
    const { ExamStore, SessionStore, SettingsStore, StudentStore } = this.props.store;
    let { pathname } = this.props.routing.location;
    const examSid = this.props.exam.sid;

    this.setState({
      enrollmentSid,
      userSid,
      sessionSid,
      configurationSid
    });

    this.props.parent.setState({
      changeRequest: false,
      readonly: false,
      scheduled: false
    });

    if(
      drawerContent &&
      drawerContent !== 'DeleteExamException' &&
      drawerContent !== 'LocateProctor' &&
      drawerContent !== 'UnlockExamException' &&
      drawerContent !== 'Impersonate' &&
      drawerContent !== 'AddAttempt'  &&
      drawerContent !== 'NeedsReview'
    ) {
      toggleDrawer(e, this.props.parent, drawerContent);
    }

    if(drawerContent === 'ExamException' || drawerContent === 'AssignProctor' || drawerContent === 'EditProctor') {
      pathname += `?enrollment=${enrollmentSid}&session=${sessionSid}`;

      this.props.parent.setState({
        crossListed,
        parentSchool
      });

      this.props.routing.push(pathname);
    } else if(drawerContent === 'EditExamException') {
      // Edit an accommodation
      pathname += `?accommodation=${configurationSid}`;
      this.props.routing.push(pathname);
    } else if(drawerContent === 'EditScheduledExamException') {
      // View an accommodation
      pathname += `?accommodation=${configurationSid}`;
      this.props.routing.push(pathname);

      this.props.parent.setState({
        scheduled: true
      });
    } else if(drawerContent === 'ViewExamException') {
      // View an accommodation
      pathname += `?accommodation=${configurationSid}`;
      this.props.routing.push(pathname);

      this.props.parent.setState({
        readonly: true
      });
    } else if(drawerContent === 'UnlockExamException') {
      // Unlock a locked accommodation
      const data = {
        approved: true,
        locked: false
      }

      const _this = this;

      let callback = function(){
        ExamStore.getEnrollments(examSid);
        SessionStore.showToaster(_this.props.translation.accommodation_unlocked, 'success');
      }

      ExamStore.updateConfigurationStatus(examSid, configurationSid, data, callback);
    } else if(drawerContent === 'DeleteExamException') {
      // Delete an accommodation
      this.deleteConfiguration(configurationSid);
    } else if(drawerContent === 'SessionDetail') {
      // Show session details
      pathname += `?session=${sessionSid}`;

      this.props.parent.setState({
        workflowModule
      });

      this.props.routing.push(pathname);
    } else if(drawerContent === 'FundingRules') {
      // Edit funding rules
      this.props.parent.setState({
        enrollmentName: studentName
      });
      pathname += `?fundingRuleScope=enrollmentSid&scopeSid=${enrollmentSid}`;
      this.props.routing.push(pathname);
    } else if(drawerContent === 'VTCReview') {
      pathname += `?accessKey=${sessionKey}`;
      this.props.routing.push(pathname);
    }

    if(drawerContent === 'LocateProctor') {
      // Pass the sessionSid to the parent to be used in the drawer
      this.props.parent.setState({
        sessionSid
      })

      // Get the student’s location and open the drawer
      SessionStore.getProfile(userSid, true, this.props.parent, (e) => {toggleDrawer(e, this.props.parent, drawerContent)});
    }

    if(drawerContent === 'MessageThread') {
      this.props.parent.setState({
        userSid,
        configurationSid
      });
    }

    // Open a new tab logged in as the student
    if(drawerContent === 'Impersonate') {
      let studentWindow = null;

      if(SessionStore.userData.role.toLowerCase() === 'instructor') {
        studentWindow = window.open('', '_blank');
      }

      StudentStore.impersonate(enrollmentSid, SettingsStore.integration.accessKey, studentWindow, userSid);
    }

    // Add an attempt (creates an accommodation with 1 additional attempt)
    if(drawerContent === 'AddAttempt') {
      const _this = this;
      const { translation } = this.props;

      const createCallback = (examSid, configurationSid) => {
        const edit = () => {
          pathname += `?accommodation=${configurationSid}`;
          this.props.routing.push(pathname);

          toggleDrawer(null, _this.props.parent, 'EditExamException');
        }

        ExamStore.getEnrollments(examSid);

        const msg = {
          heading: translation.actions.add_attempt.success_heading,
          body: translation.actions.add_attempt.success_body,
          button: translation.actions.add_attempt.success_button,
          cancel: translation.actions.add_attempt.success_button_no
        }

        confirm(msg, edit);
      }


      const callback = (data) => {
        let attempts = data.attempts;
        let attemptsRemaining = data.attemptsRemaining;
        attempts++;
        attemptsRemaining++;

        data.attempts = attempts;
        data.attemptsRemaining = attemptsRemaining;

        ExamStore.configuration = data;

        ExamStore.createConfiguration(examSid, enrollmentSid, createCallback);
      }

      // get configuration from sid
      ExamStore.getConfigurationData(examSid, configurationSid, SessionStore.courseData.sid, callback);

      // get number of attempts for configuration
      // create new configuration with 1 more attempt
    }

    if(drawerContent === 'NeedsReview'){
      const callback = () => {
        ExamStore.getEnrollments(examSid)
      }
      ExamStore.setExamSessionAsNeedsReview(examSid, SessionStore.userData.installSid, sessionSid, callback);
    }
  }

  deleteConfiguration(configurationSid) {
    const { translation } = this.props;

    const msg = {
      heading: translation.delete_confirm.heading,
      body: translation.delete_confirm.body,
      button: translation.delete_confirm.button
    }

    confirm(msg, () => this.props.store.ExamStore.deleteConfiguration(this.props.exam.sid, configurationSid));
  }

  expandRow(i) {
    let expanded = [...this.state.expanded];

    if(expanded.indexOf(i) >= 0) {
      expanded.splice(expanded.indexOf(i), 1);
    } else {
      expanded.push(i);
    }

    const otherSessions = document.querySelector(`#other-sessions-${i} th[tabindex="0"]`);

    setTimeout(function(){
      otherSessions.focus();
    });

    this.setState({
      expanded
    });
  }

  modalitiesTranslation(modality, workflowModule) {
    const { translation } = this.props;

    if(workflowModule === 'hybrid-scheduling' && modality !== 'ad-hoc') {
      return ` (${translation.live_virtual})`
    }

    switch(modality) {
      case 'smarter-scheduling':
      case 'register-blast':
        return ` (${translation.testing_center})`;
      case 'automated':
      case 'vtc':
        return ` (${translation.unattended})`;
      case 'b-virtual':
        return ` (${translation.bvirtual})`;
      case 'instructor-as-proctor':
        return ` (${translation.instructor})`;
      case 'examity':
        return ` (${translation.examity})`;
      case 'ad-hoc':
        return ` (${translation.adhoc_proctor})`;
      case 'proctoru':
        return ` (${translation.proctoru})`;
      case 'messaging':
        return ` (${translation.proctoring_professional})`;
      default:
        return ``;
    }
  }

  renderActions(enrollment, otherSession, session) {
    const { SessionStore } = this.props.store;
    const { exam, translation } = this.props;

    function specialConfigId(enrollment) {
      if(enrollment.session.examConfiguration) {
        return enrollment.session.examConfiguration.sid;
      }

      return exam.configuration.sid;
    }

    // Determine if the session can be watched live
    const evaluatedSession = session || enrollment.session;
    const canLiveWatchSession = (
      (evaluatedSession.schedulingModule === 'automated' || (evaluatedSession.workflowModule && evaluatedSession.workflowModule.includes('hybrid'))) &&
      (evaluatedSession.platformVersion === '3') &&
      (
        evaluatedSession.status.toLowerCase() === 'disconnected' ||
        evaluatedSession.status.toLowerCase() === 'in progress' ||
        evaluatedSession.status.toLowerCase() === 'checked in' ||
        evaluatedSession.status.toLowerCase() === 'onboarding'
      )
    );

    // Roster actions
    let actions = [];

    if(!otherSession) {
      // If this is a live-watchable v3 session, add the watch live option
      if(canLiveWatchSession) {
        actions.push({
          title: translation.actions.view_session_live.label,
          action: 'SessionDetail',
          iamAction:'sp:DescribeExamSession',
          iamResource:[
            `ssrn:ss:sp:us-east:${SessionStore.userData.installSid}:exam/${this.props.exam.sid}`,
            `ssrn:ss:sp:us-east:${SessionStore.userData.installSid}:session/${enrollment.session.sid}`
          ],
          helper: translation.actions.view_session_live.helper
        });
      }
      if(
        enrollment.session.status.toLowerCase() !== 'needs proctor' &&
        (
          (
            enrollment.session.schedulingModule !== 'automated' &&
            enrollment.session.workflowModule !== 'hybrid-scheduling'
          ) || (
            enrollment.session.status.toLowerCase() !== 'scheduled' &&
            enrollment.session.status.toLowerCase() !== 'in progress' &&
            enrollment.session.status.toLowerCase() !== 'processing'
            // enrollment.session.status.toLowerCase() !== 'cancelled'
          )
        )
      ) {
        const scheduledActions = [
          {
            title: translation.actions.view_session.label,
            action: 'SessionDetail',
            iamAction:'sp:DescribeExamSession',
            iamResource:[
            `ssrn:ss:sp:us-east:${SessionStore.userData.installSid}:exam/${this.props.exam.sid}`,
            `ssrn:ss:sp:us-east:${SessionStore.userData.installSid}:session/${enrollment.session.sid}`
            ],
            helper: translation.actions.view_session.helper
          }
        ]

        actions = actions.concat(scheduledActions);
      }

      if(enrollment.session.schedulingModule === 'ad-hoc') {
        const adHocActions = [
          {
            title: translation.actions.edit_proctor.label,
            action: 'EditProctor',
            iamAction:'sp:ModifyExamSession',
            iamResource:[
            `ssrn:ss:sp:us-east:${SessionStore.userData.installSid}:exam/${this.props.exam.sid}`,
            `ssrn:ss:sp:us-east:${SessionStore.userData.installSid}:session/${enrollment.session.sid}`
            ],
            helper: translation.actions.edit_proctor.helper
          }
        ]

        actions = actions.concat(adHocActions);
      }

      if(enrollment.session.schedulingModule === 'vtc' && enrollment.session.status === 'closed') {
        const closedActions = [
          {
            title: translation.actions.review_session.label,
            action: 'VTCReview',
            helper: translation.actions.review_session.helper
          }
        ]

        actions = actions.concat(closedActions);
      }

      if(enrollment.session.status.toLowerCase() !== 'scheduled' && enrollment.session.status.toLowerCase() !== 'closed') {
        const needsProctorActions = [
          {
            title: translation.actions.funding_rule.label,
            action: 'FundingRules',
            iamAction:'sp:DescribeFundingRule',
            iamResource:[
            `ssrn:ss:sp:us-east:${SessionStore.userData.installSid}:funding`
            ],
            helper: translation.actions.funding_rule.helper
          }, {
            title: translation.actions.assign_proctor.label,
            action: 'AssignProctor',
            iamAction:'sp:CreateExamSession',
            iamResource:[
            `ssrn:ss:sp:us-east:${SessionStore.userData.installSid}:exam/${this.props.exam.sid}`,
            `ssrn:ss:sp:us-east:${SessionStore.userData.installSid}:session/${enrollment.session.sid}`
            ],
            helper: translation.actions.assign_proctor.helper
          }, {
            title: translation.actions.search_proctors.label,
            action: 'LocateProctor',
            iamAction:'sp:SearchProctors',
            iamResource:`ssrn:ss:sp:us-east:${SessionStore.userData.installSid}:proctor`,
            helper: translation.actions.search_proctors.helper
          }
        ]

        actions = actions.concat(needsProctorActions);
      }

      if(
        enrollment.session.examConfiguration &&
        enrollment.session.status.toLowerCase() !== 'scheduled'
      ) {
        // Enrollment has exam configuration and has not scheduled
        let hasConfigActions = [
          {
            title: translation.actions.delete_accommodation.label,
            action: 'DeleteExamException',
            iamAction:'sp:DeleteExamConfiguration',
            iamResource:[
            `ssrn:ss:sp:us-east:${SessionStore.userData.installSid}:exam/${this.props.exam.sid}`,
            `ssrn:ss:sp:us-east:${SessionStore.userData.installSid}:course/${SessionStore.userData.courseSid}`
            ],
            helper: translation.actions.delete_accommodation.helper
          }
        ];

        // If the configuration is not locked, it can also be edited
        if(!enrollment.session.examConfiguration.locked) {
          const editConfiguration = {
            title: translation.actions.edit_accommodation.label,
            action: 'EditExamException',
            iamAction:'sp:ModifyExamConfiguration',
            iamResource:[
            `ssrn:ss:sp:us-east:${SessionStore.userData.installSid}:exam/${this.props.exam.sid}`,
            `ssrn:ss:sp:us-east:${SessionStore.userData.installSid}:course/${SessionStore.userData.courseSid}`
            ],
            helper: translation.actions.edit_accommodation.helper
          }

          hasConfigActions.unshift(editConfiguration);
        } else {
          // Enrollment has exam configuration but it’s locked
          const viewConfiguration = {
            title: translation.actions.view_accommodation.label,
            action: 'ViewExamException',
            iamAction:'sp:ViewExamConfiguration',
            iamResource:[
            `ssrn:ss:sp:us-east:${SessionStore.userData.installSid}:exam/${this.props.exam.sid}`,
            `ssrn:ss:sp:us-east:${SessionStore.userData.installSid}:course/${SessionStore.userData.courseSid}`
            ],
            helper: translation.actions.view_accommodation.helper_locked
          }

          hasConfigActions.unshift(viewConfiguration);
        }

        // If the configuration is locked, admins can unlock it
        if(enrollment.session.examConfiguration.locked && SessionStore.userData.role.toLowerCase() === 'administrator') {
          const unlockConfiguration = {
            title: translation.actions.unlock_accommodation.label,
            action: 'UnlockExamException',
            helper: translation.actions.edit_accommodation.helper
          }

          hasConfigActions.unshift(unlockConfiguration);
        }

        actions = actions.concat(hasConfigActions)
      } else if(
        enrollment.session.examConfiguration &&
        enrollment.session.status.toLowerCase() === 'scheduled'
      ) {
        // Enrollment has exam configuration and has scheduled
        let scheduledConfigActions = [
          {
            title: translation.actions.edit_accommodation.label,
            action: 'EditScheduledExamException',
            iamAction:'sp:EditScheduledExamException',
            iamResource:[
            `ssrn:ss:sp:us-east:${SessionStore.userData.installSid}:exam/${this.props.exam.sid}`,
            `ssrn:ss:sp:us-east:${SessionStore.userData.installSid}:course/${SessionStore.userData.courseSid}`
            ],
            helper: translation.actions.edit_accommodation.helper
          }
        ];

        actions = actions.concat(scheduledConfigActions)
      } else if(
        (
          enrollment.session.status.toLowerCase() !== 'scheduled' &&
          enrollment.session.status.toLowerCase() !== 'closed' &&
          enrollment.session.status.toLowerCase() !== 'processing'
        ) || (
          enrollment.session.status.toLowerCase() === 'scheduled' &&
          (
            enrollment.session.schedulingModule.toLowerCase() === 'automated' ||
            enrollment.session.workflowModule.toLowerCase() === 'hybrid-scheduling'
          )
        )
      ) {
        // Enrollment doesn't have exam configuration and has not scheduled
        // and session status is not closed or the session is scheduled as automated
        const noConfigActions = [
          {
            title: translation.actions.add_accommodation.label,
            action: 'ExamException',
            iamAction:'sp:DescribeMessageThreads',
            iamResource:[
            `ssrn:ss:sp:us-east:${SessionStore.userData.installSid}:message`
            ],
            helper: translation.actions.add_accommodation.helper
          }
        ]

        actions = actions.concat(noConfigActions);
      }

      if(enrollment.session.status.toLowerCase() === 'closed' && !enrollment.session.examConfiguration) {
        // Enrollment’s session is closed and doesn't have an accommodation
        const closedActions = [
          {
            title: translation.actions.add_attempt.label,
            action: 'AddAttempt',
            helper: translation.actions.add_attempt.helper
          },
        ]
        if(enrollment.session.reviewed === true){
          closedActions.push({
            title: translation.actions.needs_review.label,
            action: 'NeedsReview',
            helper: translation.actions.needs_review.helper
          });
        }

        actions = actions.concat(closedActions);
      }
      if(enrollment.session.status.toLowerCase() === 'closed' && enrollment.session.examConfiguration && enrollment.session.reviewed === true) {
        // Enrollment’s session is closed and does have an accommodation
        const closedActions = [
          {
            title: translation.actions.needs_review.label,
            action: 'NeedsReview',
            helper: translation.actions.needs_review.helper
          }
        ]

        actions = actions.concat(closedActions);
      }

      const globalActions = []

      const impersonateAction = {
        title: translation.actions.impersonate.label,
        action: 'Impersonate',
        helper: translation.actions.impersonate.helper
      }

      globalActions.push(impersonateAction);

      actions = actions.concat(globalActions);

      let parentSchool = null;

      if(enrollment.rootAffiliation) {
        parentSchool = {
          name: enrollment.rootAffiliation.account.name,
          installSid: enrollment.rootAffiliation.install.sid
        }
      }

      if(enrollment.proctorGroups) {
        parentSchool.proctorGroups = enrollment.proctorGroups;
      }

      let crossListed = false;

      if(
        enrollment.rootAffiliation &&
        enrollment.rootAffiliation.install.sid !== SessionStore.userData.installSid
      ) {
        crossListed = true;
      }

      return(
        <div>
          <FauxSelect
            store={SessionStore}
            default={translation.action_select}
            options={actions}
            onClick={this.selectOption}
            key={enrollment}
            enrollmentSid={enrollment.sid}
            userSid={enrollment.userSid}
            sessionSid={enrollment.session.sid}
            configurationSid={specialConfigId(enrollment)}
            studentName={`${enrollment.firstName} ${enrollment.lastName}`}
            sessionKey={enrollment.session.accessKey}
            parent={this}
            skipText={true}
            crossListed={crossListed}
            parentSchool={parentSchool}
            workflowModule={enrollment.session.workflowModule}
          />
        </div>
      )
    } else if(
      session.status.toLowerCase() !== 'processing' &&
      session.status.toLowerCase() !== 'in progress'
    ) {
      actions = [
        {
          title: translation.actions.view_session_live.label,
          action: 'SessionDetail',
          helper: translation.actions.view_session_live.helper
        }
      ]

      return(
        <div>
          <FauxSelect
            default={translation.action_select}
            options={actions}
            onClick={this.selectOption}
            key={enrollment}
            enrollmentSid={enrollment.sid}
            user={enrollment.userSid}
            sessionSid={session.sid}
            configurationSid={specialConfigId(enrollment)}
            studentName={`${enrollment.firstName} ${enrollment.lastName}`}
            parent={this}
            skipText={true}
            workflowModule={session.workflowModule}
          />

          <button
            className="btn--outline"
            onClick={(e) => {this.handleAction(e, this.state.action, enrollment.sid, enrollment.userSid, session.sid, specialConfigId(enrollment), `${enrollment.firstName} ${enrollment.lastName}`)}}
          >
            {translation.go_button}
          </button>
        </div>
      )
    }
  }
  applyFilters(e, assignment = false) {
    const {ExamStore} = this.props.store;
    const examSid = this.props.exam.sid;

    e.preventDefault();

    let filters = {};

    const fname = ExamStore.filterParams.fname;
    const lname = ExamStore.filterParams.lname;
    const status = ExamStore.filterParams.status;


      if(fname) {
        filters.firstName = `${fname}`;
      }

      if(lname) {
        filters.lastName = `${lname}`;
      }

      if(status) {
        filters.status = status;
      }


    if(fname || lname || status) {
      ExamStore.getEnrollments(examSid, filters);
      this.setState({examEnrollments: ExamStore.examEnrollments});
    } else {
      console.log('for some reason the filters are being reset')
      this.resetFilters();
    }
  }

  resetFilters(){
    const {ExamStore} = this.props.store;
    const examSid = this.props.exam.sid;


    ExamStore.filterParams.name = '';
    ExamStore.filterParams.assigned = '';
    ExamStore.filterParams.fname  = '';
    ExamStore.filterParams.lname = '';
    ExamStore.filterParams.status = '';
    ExamStore.getEnrollments(examSid)
  }

  renderDate(date, timeZone) {
    return <time className='pseudo-status-margin'>{moment.utc(date).tz(timeZone).format('M/D/YYYY [at] h:mma z')}</time>
  }

  renderResults() {
    const { SessionStore } = this.props.store;
    const { translation } = this.props;
    const { isLimitedScope } = this.props.exam
    const { userTimezone } = this.props.store.SessionStore;
    let examEnrollments = this.state.examEnrollments;

    if(!examEnrollments) {
      examEnrollments = this.props.examEnrollments;
    }

    const _this = this;

    function specialConfig(enrollment) {
      if(enrollment.session.examConfiguration && enrollment.session.examConfiguration.approved) {
        return (
          <span className="table-note">{translation.special_accommodation}</span>
        )
      } else if(enrollment.session.examConfiguration && !enrollment.session.examConfiguration.approved) {
        return (
          <span className="table-note">
            {translation.special_accommodation}<br/>
            ({translation.pending})
          </span>
        )
      }

      return '';
    }

    function showExpand(otherSessions, i) {
      if(otherSessions.length > 0) {
        return (
          <button
            className={`btn--expand ${_this.state.expanded.indexOf(i) >= 0 ? 'expanded' : ''}`}
            onClick={() => {_this.expandRow(i)}}
          >
            <span className="meta">{translation.expand}</span>
          </button>
        );
      }

      return '';
    }

    function showAttempts(key, i) {
      if(key.otherSessions.length > 0) {
        return (
          <tr className={`row-collapsed ${_this.state.expanded.indexOf(i) >= 0 ? 'expanded' : ''}`}>
            <td colSpan="4">
              <table id={`other-sessions-${i}`}>
                <thead>
                  <tr>
                    <th id={`heading-${i}-status`} scope="col" tabIndex="0">{translation.status}</th>
                    <th id={`heading-${i}-date`} scope="col">{translation.date}</th>
                    <th id={`heading-${i}-actions`} scope="col">{translation.action}</th>
                  </tr>
                </thead>
                <tbody>
                  {key.otherSessions.map(
                    (session, j) =>
                    <tr key={j}>
                      <td aria-labelledby={`heading-${i}-status`}>
                        <span className={`pill--outside pill--${session.status.toLowerCase().replace(' ', '-')}`}>
                          {session.status}
                        </span>
                      </td>
                      <td aria-labelledby={`heading-${i}-date`}>
                        {session.appointmentDate &&
                          <span>{moment.utc(session.appointmentDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z')}</span>
                        }

                        {!session.appointmentDate &&
                          <span className="status-closed">{translation.not_scheduled}</span>
                        }
                      </td>
                      <td aria-labelledby={`heading-${i}-actions`} className="actions">
                        {_this.renderActions(key, true, session)}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </td>
          </tr>
        )
      }

      return null;
    }

    if(!examEnrollments || (!examEnrollments.length && !SessionStore.loading)) {
      return (
        <span className="no-results">
          {!this.state.status &&
            translation.no_results
          }

          {this.state.status &&
            translation.no_results_filtered
          }
        </span>
      )
    } else if(SessionStore.loadingCalls.indexOf('GetProctorGroups') < 0) {
      return (
        <div>
          {isLimitedScope &&
            <h2 onClick={(e) => {
              toggleDrawer(e, this.props.parent, 'StudentAssignment')}
            }>
              {translation.studentAssignment}
            </h2>
          }

        <table>
          <thead>
            <tr>
              <th id="heading-name" className="subtitle" scope="col">{translation.student}</th>
              <th id="heading-notes" className="subtitle" scope="col">{translation.notes}</th>
              <th id="heading-status" className="subtitle" scope="col">{translation.status}</th>
              <th id="heading-actions" className="subtitle table-action" scope="col">{translation.action}</th>
            </tr>
          </thead>
          <tbody>
            {examEnrollments.map(
              (key, i) => {
                if(
                  !_this.state.status ||
                  key.session.status.toLowerCase() === _this.state.status
                ) {
                  return ([
                    <tr key={i}>
                      {/* <td className="active">{key.firstName} {key.lastName} <em className="success">Active Now</em></td> */}
                      <td aria-labelledby="heading-name">
                        <div className="cell-wrap">
                          {key.lastName}, {key.firstName}

                          {showExpand(key.otherSessions, i)}
                        </div>
                      </td>

                      <td aria-labelledby="heading-notes">
                        {specialConfig(key)}

                        {
                          key.session.status.toLowerCase() === 'scheduled' && key.session.schedulingModule === 'ad-hoc' &&
                          <span className="table-note">{translation.adHoc}</span>
                        }
                        {
                          key.session.status.toLowerCase() === 'closed' &&
                          (key.session.workflowModule.toLowerCase() === 'automated' ||
                          key.session.workflowModule.toLowerCase() === 'hybrid-scheduling') &&
                          key.session.auditStatus === "Pending Audit" &&
                            <span className={'pill pill--processing'}>
                              {key.session.auditStatus}
                            </span>

                        }

                        {
                          key.session.status.toLowerCase() === 'closed' &&
                          (key.session.workflowModule.toLowerCase() === 'automated' ||
                          key.session.workflowModule.toLowerCase() === 'hybrid-scheduling') &&
                            <span className={`pill ${key.session.reviewed ? 'pill--resolved': ''}`}>
                              {key.session.reviewed ? translation.enrollment.reviewed: translation.enrollment.needsReview}
                            </span>
                        }

                        {
                          key.rootAffiliation &&
                          key.rootAffiliation.install.sid !== SessionStore.userData.installSid &&
                          <span aria-describedby={`visitor-description-${i}`}>
                            {translation.visiting_student.heading}
                          </span>
                        }

                        {
                          key.rootAffiliation &&
                          key.rootAffiliation.install.sid !== SessionStore.userData.installSid &&
                          <div className="tooltip">
                            <span
                              className="tooltip__label"
                              role="presentation"
                              aria-hidden="true"
                            >(?)</span>

                            <div
                              id={`visitor-description-${i}`}
                              className="tooltip__body"
                              role="tooltip"
                            >
                              <div className="tooltip__copy">
                                <strong className="subtitle tooltip__title">
                                  {key.rootAffiliation.account.name}
                                </strong>

                                <p>
                                  {translation.visiting_student.body}
                                </p>

                                <ProctorGroupList
                                  proctorGroups={key.proctorGroups}
                                  {...this.props}
                                />
                              </div>
                            </div>
                          </div>
                        }
                      </td>
                      <td aria-labelledby="heading-status">
                        <span className={`pill--outside pill--${key.session.status.toLowerCase().replace(' ', '-')}`}>
                          {key.session.status}

                          {
                            this.modalitiesTranslation(key.session.schedulingModule, key.session.workflowModule)
                          }

                        </span>

                        {
                          (
                            key.session.status.toLowerCase() === 'scheduled' ||
                            key.session.status.toLowerCase() === 'incident' ||
                            key.session.status.toLowerCase() === 'closed'
                          ) && key.session.schedulingModule !== 'automated' &&

                          this.renderDate(key.session.appointmentDate, userTimezone)
                        }

                        {
                          key.session.schedulingModule === 'automated' &&
                          key.session.status.toLowerCase() === 'closed' &&

                          this.renderDate(key.session.appointmentDate, userTimezone)
                        }
                        {key.session.location && key.session.location.friendlyName &&
                          <p className='pseudo-status-margin'>
                            {translation.provider} {key.session.location.friendlyName}
                          </p>
                        }

                      </td>
                      <td aria-labelledby="heading-actions" className="actions">
                        {this.renderActions(key)}
                      </td>
                    </tr>,
                    showAttempts(key, i)
                  ])
                }

                return null;
              }
            )}
          </tbody>
        </table>
        </div>
      )
    }
  }

  render() {
    const {ExamStore, SessionStore} = this.props.store;
    const { translation } = this.props;

    return (
      <section className="panel__section">


        <div className='panel__heading__content'>
          <h2 className="panel__heading">{translation.heading}</h2>


          <a className="link--button" onClick={() => {
            const missingStudentModal = (
              <div>
                <b><p>{translation.modal.heading} </p></b>
                <ul>
                  {translation.modal.reasons.map(item => {
                    return <li>{item}</li>
                  })}
                </ul>
              </div>
            );

            SessionStore.showModal = true;
            SessionStore.modalContent = missingStudentModal;
            SessionStore.modalSmall = true;
            SessionStore.modalShort = true;
            SessionStore.modalLoaded = true;

          }}>{translation.modal.link}</a>
        </div>



        <form className="filter" onSubmit={(e) => {this.applyFilters(e)}}>
          <div className="wrap">
            <fieldset className="filter__filters">
              <ul className="fields fields--inline">
                <li><legend>{translation.filter_heading}:</legend></li>
                <li>
                  <label className="meta" htmlFor="filter-fname">
                    {translation.name}
                  </label>
                  <input
                    type="text"
                    id="filter-fname"
                    placeholder={translation.name}
                    onChange={(e) => {ExamStore.filterParams.fname = e.target.value}}
                    value={ExamStore.filterParams.fname}

                  />
                </li>
                <li>
                  <label className="meta" htmlFor="filter-lname">
                    {translation.lname}
                  </label>
                  <input
                    type="text"
                    id="filter-lname"
                    placeholder={translation.lname}
                    onChange={(e) => {ExamStore.filterParams.lname = e.target.value}}
                    value={ExamStore.filterParams.lname}
                  />
                </li>
                <li>
                  <label className="select panel__filter" htmlFor="filter-status">
                    <select
                      id="filter-status"
                      onChange={(e) => {ExamStore.filterParams.status = e.target.value}}
                      defaultValue={ExamStore.filterParams.status}
                    >
                      <option value="">{translation.filter.status_all}</option>
                      {translation.filter.status_options.map(
                        (status, i) =>
                        <option value={status.toLowerCase()} key={i}>{status}</option>
                      )}
                    </select>
                  </label>
                </li>
              </ul>
            </fieldset>
            <div className="actions">
              <button
                className="btn"
                type="submit"
              >
                {translation.filter_button}
              </button>

              <button
                className="btn btn--outline"
                type="reset"
                onClick={this.resetFilters}
              >
                {translation.reset}
              </button>
            </div>
          </div>
        </form>


        <label className="meta" htmlFor="filter-status">
        </label>



        {this.renderResults()}

        <LoadMore
          tableContainer={true}
          url={ExamStore.overviewNext}
          group={ExamStore.examEnrollments}
          store={ExamStore}
          resultsName="enrollments"
          text="load More"
          onLoad={(examEnrollments)=> {
            this.setState({
              examEnrollments
            })
          }}
          {...this.props}
        />
      </section>
    )
  }
})

export default translate('StudentOverview')(StudentOverview);



// WEBPACK FOOTER //
// ./src/app/components/Modules/StudentOverview.js